<template>
    <div class="page">
        <!-- <modalTerms ref="modalTerms" /> -->
        <terms_modal ref="terms_modal" />
        <div class="mask"></div>

        <div class="page-ctx bg">
            <div class="center page-inner flex-between">
                <div class="page-poster">
                    <img src="../../static/login/loginLogo.png" class="titleImg" alt="" />
                    <div class="myTitle">敲响中国爵士鼓制造业的新乐章</div>
                </div>

                <div class="inner form-box">
                    <div class="input-wrap">
                        <div class="tab-box">
                            <div class="tab-item">用户注册</div>
                        </div>

                        <template>
                            <div class="input-box">
                                <span>手机号</span>
                                <input type="text" placeholder="请输入手机号码" v-model="form.phone" />
                            </div>

                            <mobile_sms :form="form" />

                            <div class="input-box">
                                <span>设置密码</span>
                                <input type="password" placeholder="请输入密码" v-model="form.pass" />
                            </div>

                            <div class="input-box">
                                <span>确认密码</span>
                                <input type="password" placeholder="请输入密码" v-model="form.pass2" />
                            </div>

                            <div class="btn-box">
                                <button class="btn-ripple" @click="do_submit()">注册</button>
                            </div>

                            <div class="register-box">
                                <span>
                                    <router-link to="/login">已有账号，直接登录</router-link>
                                </span>
                            </div>

                            <div class="terms-box">
                                <span class="terms-check" @click="is_agree = !is_agree">
                                    <img v-if="is_agree" src="@/static/common/check1.png" alt="" />
                                    <img v-else src="@/static/common/check0.png" alt="" />
                                    我已阅读并同意
                                </span>
                                <span class="terms-text" @click="terms_open(114)">《会员注册协议》</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mobile_sms from '@/components/login/mobile_sms.vue' //短信验证码
import utilForm from '@/util/utilForm.js'
// import SmsLogin from "@/components/login/SmsLogin.vue"; //短信验证码
// import modalTerms from "@/components/modals/modalTerms.vue"; //协议弹窗
import terms_modal from '@/components/account/terms_modal.vue' //协议弹窗

import { mapState } from 'vuex'

export default {
    name: 'login',
    components: {
        mobile_sms,
        // modalTerms,
        terms_modal,
    },
    data() {
        return {
            is_agree: false,

            mode: '账号密码', //微信扫码
            tabType: 'PASS', //登录方式
            agreed: false,

            form: {
                phone: '',
                code: '',
                pass: '',
                pass2: '',
                invite_id: '',
            },
        }
    },
    computed: {
        ...mapState(['logo']),
    },
    created() {},
    watch: {
        is_agree(val) {
            this.$refs.terms_modal.checkSwitch(val)
        },
    },

    methods: {
        agreeSwitch(val) {
            this.is_agree = val
        },
        terms_open(id) {
            this.$refs.terms_modal.init(id)
        },

        do_submit() {
            let reg_phone = /^1[3-9]\d{9}$/
            let reg_email = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/

            if (!reg_phone.test(this.form.phone)) {
                alertErr('请输入正确的手机号')
                return
            }
            if (!this.form.code) {
                alertErr('请输入验证码')
                return
            }
            if (!this.form.pass) {
                alertErr('请输入密码')
                return
            }
            if (!this.form.pass2) {
                alertErr('请输入确认密码')
                return
            }
            if (this.form.pass != this.form.pass2) {
                alertErr('两次密码不一致')
                return
            }

            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'login_phoneReg',
                    ...this.form,
                },
            }).then((res) => {
                alert(res)
                if (res.code == 200) {
                    this.$router.push('/login')
                }
            })
        },

        //条款
        onClick_shengming() {
            this.$router.push('/banquan')
        },
        onClick_yinsi() {
            this.$router.push('/yinsi')
        },
    },
}
</script>

<style scoped lang="less">
.page {
    position: relative;

    .page-ctx.bg {
        background: url(../../static/login/loginBg.png) no-repeat;
        background-size: cover cover;
    }
    // background: rgba(255, 76, 41, 0.95);

    // .mask {

    //   background-size: cover;
    //   position: absolute;
    //   content: "";
    //   left: 0;
    //   bottom: 0;
    //   width: 100%;
    //   height: 100%;
    //   // opacity: 0.1;
    //   pointer-events: none;
    // }

    .page-inner {
    }

    .page-poster {
        .titleImg {
            width: 750px;
        }

        .myTitle {
            margin-top: 55px;
            font-size: 40px;
            line-height: 40px;
            color: #ffffff;
        }
    }

    .center {
        height: 780px;
        width: @width;
        margin: 0 auto;
        background: transparent;
        align-items: center;
        position: relative;

        .inner {
            position: relative;

            width: 480px;
            height: 600px;
            background: #ffffff;
            box-shadow: 0px 2px 30px 1px rgba(79, 79, 79, 0.3);
            border-radius: 16px 16px 16px 16px;
            overflow: hidden;

            padding: 40px 40px 70px;
            opacity: 1;
            border-radius: 10px;

            .mode-toggle {
                position: absolute;
                right: 12px;
                top: 12px;

                img {
                    width: 64px;
                    cursor: pointer;
                }
            }

            .left {
            }

            .right {
                // width: 480px;
                // height: 480px;
                // background: #ffffff;
                // box-shadow: 0px 10px 20px rgba(1, 100, 98, 0.2);
                // opacity: 1;
                // border-radius: 10px;

                // padding: 40px 40px 30px 40px;
            }
        }

        .tab-box {
            margin-bottom: 40px;
            .flex-center();

            .tab-item {
                font-weight: 500;
                font-size: 26px;
                color: #333333;

                &:first-child {
                    // &:after {
                    //   content: "";
                    //   display: inline-block;
                    //   width: 2px;
                    //   height: 24px;
                    //   background-color: #ccc;
                    //   margin: 0 30px;
                    //   position: relative;
                    //   top: 3px;
                    // }
                }

                &.active {
                    color: #333333;
                }
            }
        }

        .input-wrap {
            width: 400px;
            margin: 0 auto;
        }

        .input-box {
            margin-bottom: 20px;
            width: 100%;
            height: 50px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            border-radius: 4px;
            .flex-between();
            overflow: hidden;

            span {
                display: inline-block;
                width: 95px;
                border-right: 1px solid #ccc;

                font-family: OPPOSans, OPPOSans;
                font-weight: 400;
                font-size: 14px;
                color: #7d7d7d;
                text-indent: 1em;
            }

            img {
                width: 36px;
            }

            input {
                flex: 2;
                height: 100%;
                padding-left: 16px;
                font-size: 14px;
                color: #000;

                &::-webkit-input-placeholder {
                    font-size: 14px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #d7d7d7;
                }
            }
        }

        .agree-box {
            text-align: left;
            margin-top: 20px;
            .flex-between();

            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 24px;
            color: #999999;

            a {
                color: #ff7327;
            }
        }

        .btn-box {
            margin-top: 40px;

            button {
                width: 100%;
                height: 44px;
                background: #ff4d00;
                font-size: 18px;
                font-weight: 500;
                color: #ffffff;
            }
        }

        .register-box {
            text-align: center;
            margin-top: 30px;
            font-size: 14px;

            a {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 24px;
                color: #ff7327;
                border-bottom: 1px solid #ff7327;
            }
        }
    }
}

.terms-box {
    position: absolute;
    height: 40px;
    background: #f5f6f8;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    justify-content: flex-start;
    padding-left: 20px;
    text-align: center;

    .terms-check {
        cursor: pointer;
        font-family: OPPOSans, OPPOSans;
        font-weight: 400;
        font-size: 12px;
        color: #999999;

        img {
            margin-right: 10px;
            width: 18px;
            height: 18px;
        }
    }

    .terms-text {
        cursor: pointer;
        font-family: OPPOSans, OPPOSans;
        font-weight: 400;
        font-size: 12px;
        color: #999999;

        &:hover {
            color: #ff7327;
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/page/register.less"></style>
